import React from 'react';

/**
 * La légende à pastilles d'un graphe ventilé par catégorie, en HTML : elle se
 * lit de loin sur un écran projeté, là où l'infobulle de chart.js demande une
 * souris que personne n'a dans la salle.
 */
const CategoryLegend = ({ categories, colorOf, values, unit, formatValue }) => (
  <ul className="category-legend">
    {categories.map((category, index) => (
      <li key={category} className="category-legend-item">
        <span className="category-legend-dot" style={{ backgroundColor: colorOf(index) }} />
        <span className="category-legend-label">{category}</span>
        {values && (
          <span className="category-legend-value">
            {formatValue(values[category])} {unit}
          </span>
        )}
      </li>
    ))}
  </ul>
);

export default CategoryLegend;
